DATENSCHUTZERKLÄRUNG (B2B)

1. Verantwortlicher

Name/Firma: [einzutragen]
Adresse: [einzutragen]
E-Mail: [einzutragen]

2. Anwendungsbereich

Diese Datenschutzerklärung gilt für die Nutzung der Anwendung.

3. Verarbeitete Daten

- Registrierungsdaten
- Nutzungsdaten
- Inhalte der Nutzer

4. Zweck der Verarbeitung

- Betrieb der Anwendung
- Sicherheit und Fehleranalyse

5. Rechtsgrundlagen

Art. 6 Abs. 1 lit. b und f DSGVO

6. Dienstleister

Einsatz von Auftragsverarbeitern gemäß Art. 28 DSGVO.

7. Künstliche Intelligenz

Keine automatisierte Entscheidungsfindung mit Rechtswirkung.

8. Speicherung und Löschung

Keine Garantie für dauerhafte Speicherung.

9. Weitergabe

Keine Weitergabe außer gesetzlich erforderlich.

10. Rechte

Auskunft, Berichtigung, Löschung, Widerspruch.

11. Änderungen

Änderungen jederzeit möglich.
